import {styled} from '@mui/material';
import {StyledGrid} from 'presentation/components/Grid';

export const StyledGridRoot = styled(StyledGrid.Root)`
	padding: 0px;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 32px 32px 0px;
	}
`;
